import { render } from "./AnalysisDeliveryPrefecturePage.vue?vue&type=template&id=64e80e20"
import script from "./AnalysisDeliveryPrefecturePage.vue?vue&type=script&lang=js"
export * from "./AnalysisDeliveryPrefecturePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__